var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgScheduleFilled(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 2V5",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 2V5",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 3C4.23858 3 2 5.23858 2 8V17C2 19.7614 4.23858 22 7 22H17C19.7614 22 22 19.7614 22 17V8C22 5.23858 19.7614 3 17 3H7ZM7.5 14.25C8.05228 14.25 8.5 13.8023 8.5 13.25C8.5 12.6977 8.05228 12.25 7.5 12.25C6.94772 12.25 6.5 12.6977 6.5 13.25C6.5 13.8023 6.94772 14.25 7.5 14.25ZM8.5 16.75C8.5 17.3023 8.05228 17.75 7.5 17.75C6.94772 17.75 6.5 17.3023 6.5 16.75C6.5 16.1977 6.94772 15.75 7.5 15.75C8.05228 15.75 8.5 16.1977 8.5 16.75ZM12 14.25C12.5523 14.25 13 13.8023 13 13.25C13 12.6977 12.5523 12.25 12 12.25C11.4477 12.25 11 12.6977 11 13.25C11 13.8023 11.4477 14.25 12 14.25ZM13 16.75C13 17.3023 12.5523 17.75 12 17.75C11.4477 17.75 11 17.3023 11 16.75C11 16.1977 11.4477 15.75 12 15.75C12.5523 15.75 13 16.1977 13 16.75ZM16.5 14.25C17.0523 14.25 17.5 13.8023 17.5 13.25C17.5 12.6977 17.0523 12.25 16.5 12.25C15.9477 12.25 15.5 12.6977 15.5 13.25C15.5 13.8023 15.9477 14.25 16.5 14.25ZM17.5 16.75C17.5 17.3023 17.0523 17.75 16.5 17.75C15.9477 17.75 15.5 17.3023 15.5 16.75C15.5 16.1977 15.9477 15.75 16.5 15.75C17.0523 15.75 17.5 16.1977 17.5 16.75ZM7.5 4.5C5.29086 4.5 3.5 6.29086 3.5 8.5V9.5H20.5V8.5C20.5 6.29086 18.7091 4.5 16.5 4.5H7.5Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgScheduleFilled);
export default __webpack_public_path__ + "static/media/schedule-filled.bad0b3f3b8cc385debd1c4fc99f4d47a.svg";
export { ForwardRef as ReactComponent };